import { useState } from "react";
import { signup } from "./AuthService";
import { useNavigate } from "react-router-dom";

export default function Signup(){

  const nav = useNavigate();
  const [form,setForm] = useState({
    firstName:"",
    lastName:"",
    username:"",
    email:[],
    phoneNos:[],
    password:""
  });

  const submit = async (e)=>{
    e.preventDefault();
    await signup(form);
    nav("/login");
  };

  return (
    <div style={{
      height:"100vh",
      display:"flex",
      justifyContent:"center",
      alignItems:"center"
    }}>
      <div className="card" style={{ width:"450px" }}>

        <div style={{ textAlign:"center", marginBottom:"15px" }}>
          <h2>Create Account</h2>
          <p style={{ color:"#6b7280" }}>Start managing your finances</p>
        </div>

        <form onSubmit={submit} className="form-grid">

          <input className="input" placeholder="First Name"
            onChange={e=>setForm({...form,firstName:e.target.value})} required />

          <input className="input" placeholder="Last Name"
            onChange={e=>setForm({...form,lastName:e.target.value})} required />

          <input className="input form-full" placeholder="Username"
            onChange={e=>setForm({...form,username:e.target.value})} required />

          <input className="input" placeholder="Email"
            onChange={e=>setForm({...form,email:[e.target.value]})} required />

          <input className="input" placeholder="Phone"
            onChange={e=>setForm({...form,phoneNos:[e.target.value]})} />

          <input className="input form-full" type="password" placeholder="Password"
            onChange={e=>setForm({...form,password:e.target.value})} required />

          <div className="form-full" style={{ textAlign:"right" }}>
            <button className="btn btn-primary" type="submit">
              Create Account
            </button>
          </div>
        </form>

        <div style={{ textAlign:"center", marginTop:"10px", fontSize:"14px" }}>
          Already have an account?{" "}
          <span
            style={{ color:"#6366f1", cursor:"pointer" }}
            onClick={()=>nav("/login")}
          >
            Login
          </span>
        </div>

      </div>
    </div>
  );
}
